import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex space-x-2 mb-8" }
const _hoisted_3 = { class: "w-full mb-2" }
const _hoisted_4 = { class: "text-xs text-slate-500" }
const _hoisted_5 = { class: "text-xs text-slate-500" }
const _hoisted_6 = { class: "flex space-x-2 mb-8" }
const _hoisted_7 = { class: "w-full mb-2" }
const _hoisted_8 = { class: "text-xs text-slate-500" }
const _hoisted_9 = { class: "text-xs text-slate-500" }
const _hoisted_10 = { class: "flex space-x-2 mb-8" }
const _hoisted_11 = { class: "w-full mb-2" }
const _hoisted_12 = { class: "text-xs text-slate-500" }
const _hoisted_13 = { class: "text-xs text-slate-500" }
const _hoisted_14 = { class: "flex space-x-2 mb-8" }
const _hoisted_15 = { class: "w-full mb-2" }
const _hoisted_16 = { class: "text-xs text-slate-500" }
const _hoisted_17 = { class: "text-xs text-slate-500" }
const _hoisted_18 = { class: "flex space-x-2 mb-8" }
const _hoisted_19 = { class: "w-full mb-2" }
const _hoisted_20 = { class: "text-xs text-slate-500" }
const _hoisted_21 = { class: "text-xs text-slate-500" }
const _hoisted_22 = { class: "flex space-x-2 mb-8" }
const _hoisted_23 = { class: "w-full mb-2" }
const _hoisted_24 = { class: "text-xs text-slate-500" }
const _hoisted_25 = { class: "text-xs text-slate-500" }
const _hoisted_26 = { class: "flex space-x-2 mb-8" }
const _hoisted_27 = { class: "w-full mb-2" }
const _hoisted_28 = { class: "text-xs text-slate-500" }
const _hoisted_29 = { class: "text-xs text-slate-500" }
const _hoisted_30 = { class: "flex space-x-2 mb-8" }
const _hoisted_31 = { class: "w-full mb-2" }
const _hoisted_32 = { class: "text-xs text-slate-500" }
const _hoisted_33 = { class: "text-xs text-slate-500" }
const _hoisted_34 = { class: "flex space-x-2 mb-8" }
const _hoisted_35 = { class: "w-full mb-2" }
const _hoisted_36 = { class: "text-xs text-slate-500" }
const _hoisted_37 = { class: "text-xs text-slate-500" }
const _hoisted_38 = { class: "flex space-x-2 mb-8" }
const _hoisted_39 = { class: "w-full mb-2" }
const _hoisted_40 = { class: "text-xs text-slate-500" }
const _hoisted_41 = { class: "text-xs text-slate-500" }
const _hoisted_42 = { class: "w-full mb-6" }
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = { class: "w-full mb-6" }
const _hoisted_45 = { class: "mb-4" }
const _hoisted_46 = { class: "mb-4" }
const _hoisted_47 = { class: "mb-4" }
const _hoisted_48 = { class: "mb-4" }
const _hoisted_49 = { class: "mb-4" }
const _hoisted_50 = { class: "mb-4" }
const _hoisted_51 = { class: "mb-4 space-y-1" }
const _hoisted_52 = { class: "mb-4" }
const _hoisted_53 = { class: "mb-4" }
const _hoisted_54 = { class: "mb-4" }
const _hoisted_55 = { class: "mb-4" }
const _hoisted_56 = { class: "mb-4" }

import {
    IonPage,
    IonContent,
} from "@ionic/vue";
import ButtonComponent from '@/components/ButtonComponent.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import SelectOptions from "@/components/inputs/SelectOptions.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import BirthdayPicker from "@/components/inputs/DatePicker.vue";
import GenderSelection from "@/components/inputs/GenderSelection.vue";
import MobileNumber from "@/components/inputs/MobileNumber.vue";
import PasswordInput from "@/components/inputs/PasswordInput.vue";
import BadgeComponent from "@/components/BadgeComponent.vue";
import QuantitySelector from "@/components/inputs/QuantitySelector.vue";

import colors from 'tailwindcss/colors'


export default /*@__PURE__*/_defineComponent({
  __name: 'StyleSheet',
  setup(__props) {

const sampleOptions = [
    { id: '1', label: 'Colors', value: 'Colors'},
    { id: '2', label: 'Typography', value: 'Typography'},
    { id: '3', label: 'Forms', value: 'Forms'},
    { id: '4', label: 'Buttons', value: 'Buttons'},
    { id: '5', label: 'Cards', value: 'Cards'}
]

const primaryColors = [
    { hex: '#f6e8fc', color: 'bg-primary-200' },
    { hex: '#f2ddfb', color: 'bg-primary-300' },
    { hex: '#e4b8f6', color: 'bg-primary-400' },
    { hex: '#a81ae2', color: 'bg-primary-500' },
    { hex: '#7e14aa', color: 'bg-primary-600' },
    { hex: '#3b094f', color: 'bg-primary-700' },
];

const secondaryColors = [
    { hex: '#FFF8E6', color: 'bg-secondary-200' },
    { hex: '#FFF5D9', color: 'bg-secondary-300' },
    { hex: '#FFEAB0', color: 'bg-secondary-400' },
    { hex: '#FFBC00', color: 'bg-secondary-500' },
    { hex: '#BF8D00', color: 'bg-secondary-600' },
    { hex: '#594200', color: 'bg-secondary-700' },
];

const gray = [
    { hex: colors.gray[50], color: 'bg-gray-50' },
    { hex: colors.gray[100], color: 'bg-gray-100' },
    { hex: colors.gray[200], color: 'bg-gray-200' },
    { hex: colors.gray[300], color: 'bg-gray-300' },
    { hex: colors.gray[400], color: 'bg-gray-400' },
    { hex: colors.gray[500], color: 'bg-gray-500' },
    { hex: colors.gray[600], color: 'bg-gray-600' },
    { hex: colors.gray[700], color: 'bg-gray-700' },
    { hex: colors.gray[800], color: 'bg-gray-800' },
    { hex: colors.gray[900], color: 'bg-gray-900' },
]

const neutral = [
    { hex: colors.neutral[50], color: 'bg-neutral-50' },
    { hex: colors.neutral[100], color: 'bg-neutral-100' },
    { hex: colors.neutral[200], color: 'bg-neutral-200' },
    { hex: colors.neutral[300], color: 'bg-neutral-300' },
    { hex: colors.neutral[400], color: 'bg-neutral-400' },
    { hex: colors.neutral[500], color: 'bg-neutral-500' },
    { hex: colors.neutral[600], color: 'bg-neutral-600' },
    { hex: colors.neutral[700], color: 'bg-neutral-700' },
    { hex: colors.neutral[800], color: 'bg-neutral-800' },
    { hex: colors.neutral[900], color: 'bg-neutral-900' },
]

const red = [
    { hex: colors.red[50], color: 'bg-red-50' },
    { hex: colors.red[100], color: 'bg-red-100' },
    { hex: colors.red[200], color: 'bg-red-200' },
    { hex: colors.red[300], color: 'bg-red-300' },
    { hex: colors.red[400], color: 'bg-red-400' },
    { hex: colors.red[500], color: 'bg-red-500' },
    { hex: colors.red[600], color: 'bg-red-600' },
    { hex: colors.red[700], color: 'bg-red-700' },
    { hex: colors.red[800], color: 'bg-red-800' },
    { hex: colors.red[900], color: 'bg-red-900' },
]

const orange = [
    { hex: colors.orange[50], color: 'bg-orange-50' },
    { hex: colors.orange[100], color: 'bg-orange-100' },
    { hex: colors.orange[200], color: 'bg-orange-200' },
    { hex: colors.orange[300], color: 'bg-orange-300' },
    { hex: colors.orange[400], color: 'bg-orange-400' },
    { hex: colors.orange[500], color: 'bg-orange-500' },
    { hex: colors.orange[600], color: 'bg-orange-600' },
    { hex: colors.orange[700], color: 'bg-orange-700' },
    { hex: colors.orange[800], color: 'bg-orange-800' },
    { hex: colors.orange[900], color: 'bg-orange-900' },
]

const yellow = [
    { hex: colors.yellow[50], color: 'bg-yellow-50' },
    { hex: colors.yellow[100], color: 'bg-yellow-100' },
    { hex: colors.yellow[200], color: 'bg-yellow-200' },
    { hex: colors.yellow[300], color: 'bg-yellow-300' },
    { hex: colors.yellow[400], color: 'bg-yellow-400' },
    { hex: colors.yellow[500], color: 'bg-yellow-500' },
    { hex: colors.yellow[600], color: 'bg-yellow-600' },
    { hex: colors.yellow[700], color: 'bg-yellow-700' },
    { hex: colors.yellow[800], color: 'bg-yellow-800' },
    { hex: colors.yellow[900], color: 'bg-yellow-900' },
]

const green = [
    { hex: colors.green[50], color: 'bg-green-50' },
    { hex: colors.green[100], color: 'bg-green-100' },
    { hex: colors.green[200], color: 'bg-green-200' },
    { hex: colors.green[300], color: 'bg-green-300' },
    { hex: colors.green[400], color: 'bg-green-400' },
    { hex: colors.green[500], color: 'bg-green-500' },
    { hex: colors.green[600], color: 'bg-green-600' },
    { hex: colors.green[700], color: 'bg-green-700' },
    { hex: colors.green[800], color: 'bg-green-800' },
    { hex: colors.green[900], color: 'bg-green-900' },
]

const blue = [
    { hex: colors.blue[50], color: 'bg-blue-50' },
    { hex: colors.blue[100], color: 'bg-blue-100' },
    { hex: colors.blue[200], color: 'bg-blue-200' },
    { hex: colors.blue[300], color: 'bg-blue-300' },
    { hex: colors.blue[400], color: 'bg-blue-400' },
    { hex: colors.blue[500], color: 'bg-blue-500' },
    { hex: colors.blue[600], color: 'bg-blue-600' },
    { hex: colors.blue[700], color: 'bg-blue-700' },
    { hex: colors.blue[800], color: 'bg-blue-800' },
    { hex: colors.blue[900], color: 'bg-blue-900' },
]

const violet = [
    { hex: colors.violet[50], color: 'bg-violet-50' },
    { hex: colors.violet[100], color: 'bg-violet-100' },
    { hex: colors.violet[200], color: 'bg-violet-200' },
    { hex: colors.violet[300], color: 'bg-violet-300' },
    { hex: colors.violet[400], color: 'bg-violet-400' },
    { hex: colors.violet[500], color: 'bg-violet-500' },
    { hex: colors.violet[600], color: 'bg-violet-600' },
    { hex: colors.violet[700], color: 'bg-violet-700' },
    { hex: colors.violet[800], color: 'bg-violet-800' },
    { hex: colors.violet[900], color: 'bg-violet-900' },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "font-bold text-primary mb-4" }, "Stylesheet", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "font-bold text-gray-700 mb-4" }, "Colors", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Primary Colors", -1)),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(primaryColors, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / primaryColors.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(secondaryColors, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / secondaryColors.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Gray Colors", -1)),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(gray, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / gray.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Neutral Colors", -1)),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(neutral, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / neutral.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Red Colors", -1)),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(red, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / red.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_21, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Orange Colors", -1)),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orange, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / orange.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_25, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Yellow Colors", -1)),
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(yellow, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / yellow.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", _hoisted_28, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_29, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Green Colors", -1)),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(green, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / green.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("p", _hoisted_32, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_33, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Blue Colors", -1)),
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(blue, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / blue.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("p", _hoisted_36, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_37, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "mb-4 text-gray-600 font-medium" }, "Violet Colors", -1)),
            _createElementVNode("div", _hoisted_38, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(violet, (i) => {
                return _createElementVNode("div", {
                  class: "flex flex-col",
                  key: i,
                  style: _normalizeStyle({ width: 100 / violet.length + '%' })
                }, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("p", _hoisted_40, _toDisplayString(i.hex), 1),
                    _createElementVNode("p", _hoisted_41, _toDisplayString(i.color), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full h-10 rounded-xl", i.color])
                  }, null, 2)
                ], 4)
              }), 64))
            ])
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "w-full mb-6" }, [
            _createElementVNode("h2", { class: "font-bold text-gray-700 mb-4" }, "Typography"),
            _createElementVNode("div", { class: "mb-8" }, [
              _createElementVNode("h1", { class: "text-3xl font-bold mb-2" }, "Nunito"),
              _createElementVNode("p", null, "ABCDEFGHIJKLMNOPQRSTUVWXYZ"),
              _createElementVNode("p", null, "abcdefghijklmnopqrstuvwxyz"),
              _createElementVNode("p", null, "0123456789")
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-xs m-0" }, "text-xs"),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 0.75rem; /* 12px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 1rem; /* 16px */")
              ])
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-sm m-0" }, "text-sm"),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 0.875rem; /* 14px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 1.25rem; /* 20px */")
              ])
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-base m-0" }, "text-base"),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 1rem; /* 16px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 1.5rem; /* 24px */")
              ])
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-lg m-0" }, "text-lg"),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 1.125rem; /* 18px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 1.75rem; /* 28px */")
              ])
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-xl m-0" }, "text-xl"),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 1.25rem; /* 20px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 1.75rem; /* 28px */")
              ])
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-2xl m-0" }, "text-2xl"),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 1.5rem; /* 24px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 2rem; /* 32px */")
              ])
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-3xl m-0" }, "text-3xl "),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 1.875rem; /* 30px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 2.25rem; /* 36px */")
              ])
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-4xl m-0" }, "text-4xl "),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 2.25rem; /* 36px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 2.5rem; /* 40px */")
              ])
            ]),
            _createElementVNode("div", { class: "flex justify-between items-center py-2 border-b" }, [
              _createElementVNode("p", { class: "text-5xl m-0" }, "text-5xl"),
              _createElementVNode("div", { class: "w-1/2" }, [
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "font-size: 3rem; /* 48px */"),
                _createElementVNode("p", { class: "text-sm text-slate-500" }, "line-height: 1;")
              ])
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_42, [
            _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "font-bold text-gray-700 mb-4" }, "Buttons", -1)),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(ButtonComponent, {
                size: "small",
                color: "primary",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("img", {
                    class: "mr-2",
                    width: "24",
                    src: "/assets/icons/icon.png"
                  }, null, -1),
                  _createTextVNode(" Button Small ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(ButtonComponent, {
                size: "small",
                color: "primary",
                disabled: true,
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode(" Button Small ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(ButtonComponent, {
                size: "small",
                color: "primary"
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode(" Button Large ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "font-bold text-gray-700 mb-4" }, "Forms", -1)),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(TextInput, {
                type: "text",
                label: "Email",
                placeholder: "Enter phone or email",
                helper: "9123456789 or sample@email.com"
              })
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(TextInput, {
                label: "Price",
                placeholder: "Price",
                id: "price",
                "add-on-left": true,
                "add-on-text": "₱",
                type: "number"
              })
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(TextInput, {
                error: "error",
                label: "Height",
                placeholder: "Height",
                id: "height",
                "add-on-right": true,
                "add-on-text": "cm",
                type: "number"
              })
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(SelectOptions, {
                options: sampleOptions,
                label: "Sample Selector",
                id: "selector-id",
                name: "selector-name",
                placeholder: "Sample Selector"
              })
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(TextInput, {
                textarea: "",
                name: "textarea-input",
                id: "textarea-input",
                placeholder: "Sample Placeholder",
                label: "Sample Label"
              })
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createVNode(CheckboxInput, {
                id: "terms",
                modelValue: _ctx.agree,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agree) = $event)),
                label: "I have read and agree to the above terms & conditions"
              }, null, 8, ["modelValue"]),
              _createVNode(CheckboxInput, {
                id: "agree",
                modelValue: _ctx.agree,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agree) = $event)),
                "default-slot": false
              }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("div", { class: "ml-3" }, [
                    _createElementVNode("label", {
                      for: "agree",
                      class: "text-sm block leading-4"
                    }, [
                      _createTextVNode(" I agree to the "),
                      _createElementVNode("a", {
                        href: "",
                        class: "text-blue-500 text-sm"
                      }, "privacy policy"),
                      _createTextVNode(" and "),
                      _createElementVNode("a", {
                        href: "",
                        class: "text-blue-500 text-sm"
                      }, "terms & conditions")
                    ])
                  ], -1)
                ]))]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createVNode(RadioGroup, {
                options: sampleOptions,
                name: "options"
              })
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createVNode(BirthdayPicker, { label: "Birthday" })
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createVNode(GenderSelection)
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createVNode(MobileNumber, {
                label: "Mobile Number",
                placeholder: "Mobile Number"
              })
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createVNode(PasswordInput, {
                id: "password",
                label: "Password",
                placeholder: "Password"
              })
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(BadgeComponent, {
                text: "Badge",
                color: "bg-primary-900",
                textColor: "text-white",
                forwardIcon: ""
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(QuantitySelector)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})